import { Container } from './src/Main'
export { Container }
export default Container



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Main/index.ts